import { IconButton, Stack, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { parse, format, addMinutes } from 'date-fns';

interface OffsetButtonsProps {
  offsetSize: number;
  currentValue: string;
  onClick: (value: string) => void;
}

export default function OffsetButtons({ offsetSize, currentValue, onClick }: OffsetButtonsProps) {
  const handleOffsetChange = (minutes: number) => {
    const timeValue = currentValue || '00:00';
    const date = parse(timeValue, 'HH:mm', new Date());
    const newDate = addMinutes(date, minutes);
    onClick(format(newDate, 'HH:mm'));
  };

  return (
    <Stack direction="row" spacing={0} alignItems="center">
      <IconButton
        size="small"
        onMouseDown={(event) => event.preventDefault()}
        onTouchStart={(event) => event.preventDefault()}
        onClick={() => handleOffsetChange(-offsetSize)}
      >
        <RemoveIcon fontSize="small" />
      </IconButton>
      <Typography variant="subtitle2">{offsetSize}</Typography>
      <IconButton
        size="small"
        onMouseDown={(event) => event.preventDefault()}
        onTouchStart={(event) => event.preventDefault()}
        onClick={() => handleOffsetChange(offsetSize)}
      >
        <AddIcon fontSize="small" />
      </IconButton>
    </Stack>
  );
}
